/**
 * All experiment toggles (excluding native mobile app) that are active in the repo are listed here.
 * The key is the experiment key as it is defined in Optimizely.
 * The value is the variant that all traffic is set to. If an experiment is still running, the value is `null`.
 * Grouped by owners.
 */
const experiments = {
  // A/A tests
  'a-a-experiment': null,

  // AI Discovery Experience
  'fec27873-similar-hotels': null,

  // Search
  '2a7f5ff0-expedia-back-tab': null,
  '32cf4c25-srp-room-count-copy': null,
  'c747927f-deal-freeze-srp': null,
  '27d5ef4a-call-to-book-anchor': null,

  // Booking Monetisation
  '8d208c3f-picc-v3': null,

  // Booking Core Experience
  'feature-offer-check-selected-offer-ap': null,
  '1cmqc2sk-login-change-on-bovio-funnel': null,
  '90ef358d-ap-first-fold-improvement-v2': null,
  'd2314dca-pp-information-rework': null,
  'fb6c24d6-ap-rooms-list-improvements': null,
  '5007b297-redesign-searchbox': null,

  // Find
  'a8fj1jd3-color-price-calendar-2': null,
  'a08c91b8-map-improve-pins-filters': 'b',
  'a5bb8c9f-satellite-avuxi-map-mobile': 'b',
  '8783dc23-no-reviews': null,

  // Membership
  'd9258dba-confirmation-price-watch': null,
  '4f8c2e1d-cashback-explanation-homepage': null,
  '4f732294-notification-preferences': null,
  'c4684a10-feature-inline-banner-app-acquisition': null,
  '18523d38-df-toast-on-ap-web': null,
  '545a3ae7-deal-freeze-education-banner': null,
  'cd92d4b1-deal-freeze-onboarding-web-v2': null,
  'c44047ae-price-insights-our-advice': null,
  '2500a16c-separate-freeze-offer-mobile-web': null,
  'ea03ef21-my-list-visibility-web': null,

  // Landing Experience
  'd694612d-ssr-srp-anchor-preheat--v1': null,
  'c9a3a3ec-deal-freeze-exit-popup': null,

  // Affiliates
  '5c52a4af-partner-price-discrepancy-copy': null,
  '0bea45b9-activity-exit-popup': null,

  // AI Discovery Experience
  'dcbc5616-property-highlights-v1': null
}

/**
 * All long-lived feature flag toggles (excluding native mobile app) that are active in the repo are listed here.
 * The key is the experiment key as it is defined in Optimizely.
 *
 * For features whose targeting is managed in Optimizely, not in the codebase, the value is set to `null`.
 * For other features, the value is set to the same side as in Optimizely.
 * Grouped by owners.
 */
const features = {
  // Find
  'feature-hotel-availability': 'b',
  'd14be6ee-feature-app-exclusive-deal': 'b',
  'h02hslwa-app-exclusive-deal-hold-out-group': 'a',

  // Search
  'feature-web-to-app-mobile-anchor': null,
  'feature-web-to-app-mobile-non-anchor': null,
  'feature-srp-prefetch-pagination-results': null,
  'feature-hotel-price-structured-data': null,
  'feature-hotel-price-structured-data-early-serve': null,
  'feature-top-offer-delay': null,
  'feature-translate-insights': null,
  'feature-translate-reviews': null,
  'feature-srp-refresh-price': null,
  'feature-survey-banner': 'b',

  // AI Discovery Experience
  'feature-vio-mcp-ai-chat': null,

  // Landing Experience
  'feature-seo-hotel-descriptions': null,

  // Booking core experience
  'feature-offer-check-on-pp': null,
  'feature-ssr-rooms-preheat': null,
  'feature-web-to-app-mobile-gha': null

  // SIDs
}

module.exports = {experiments, features}
